import { render } from "./searchCommonSection.vue?vue&type=template&id=a83f6582&ts=true"
import script from "./searchCommonSection.vue?vue&type=script&lang=ts"
export * from "./searchCommonSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__